export default __webpack_public_path__ + "static/BhcoeAccredidation-442f2a2cba263ed3a0f476c5ca253e94.webp";